import React from "react"

import * as styles from "./Styles/CategoryList.module.scss"
import "../../styles/layouts"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)

import Loader from "./Loader"
import { Category } from "../types/category"
import { FeaturedCategory } from "../Utils/category"

const filterNoPlaceCategories = (
  categories,
  placeCountByCategories
): Array<Category> => {
  return categories.filter((c: Category | FeaturedCategory) => {
    if (Object.keys(placeCountByCategories).length == 0) {
      return true
    }
    if (c instanceof FeaturedCategory && (c.isAll || c.isOther)) {
      return true
    }
    if (placeCountByCategories[c.id] == null) {
      return false
    }
    return placeCountByCategories[c.id] > 0
  })
}

const FlatCategory = (props) => {
  const categories = filterNoPlaceCategories(
    props.categories,
    props.placeCountByCategories
  )

  return (
    <div className={styles.children}>
      {categories.map((c, i) => (
        <a
          key={i}
          href="#"
          className={styles.categoryAnchor}
          onClick={(e) => {
            if (props.componentDisabled) {
              return e.preventDefault()
            }
            props.onClick(e, c)
          }}
        >
          <div
            className={cn(
              "circle",
              props.selected == c.id ? "circle--selected" : "",
              props.componentDisabled ? "circle--disabled" : ""
            )}
          >
            {c.name}
            {props.placeCountByCategories && !isNaN(c.id) && (
              <React.Fragment>
                {c.id !== 0 && props.placeCountByCategories[c.id] && (
                  <span className={styles.placesCount}>
                    {props.placeCountByCategories[c.id]}
                  </span>
                )}
                {c.id === 0 && props.placeCountByCategories["all"] && (
                  <span className={styles.placesCount}>
                    {props.placeCountByCategories["all"]}
                  </span>
                )}
              </React.Fragment>
            )}
          </div>
        </a>
      ))}
    </div>
  )
}

const LayeredCategoryChildren = (props) => {
  return (
    <React.Fragment>
      {props.children.map((child, i) => (
        <a
          key={i}
          href="#"
          className={styles.categoryAnchor}
          onClick={(e) => {
            props.onClick(e, child)
          }}
        >
          <div
            className={cn(
              "circle",
              props.selected == child.id ? "circle--selected" : ""
            )}
          >
            {child.name}
            {props.placeCountByCategories && (
              <span className={styles.placesCount}>
                {props.placeCountByCategories[child.id]}
              </span>
            )}
          </div>
        </a>
      ))}
    </React.Fragment>
  )
}

const LayeredCategory = (props) => {
  const filteredChildren = {}
  for (let i = 0; i < props.categories.length; i++) {
    const category = props.categories[i]
    filteredChildren[category.id] = filterNoPlaceCategories(
      category.children,
      props.placeCountByCategories
    )
  }

  return (
    <React.Fragment>
      <div className={cn("l-flex", "parentCategory")}>
        <a
          href="#"
          className={styles.categoryAnchor}
          onClick={(e) => {
            props.onClick(e, { id: 0 })
          }}
        >
          <div
            className={cn(
              "circle",
              props.selected == 0 ? "circle--selected" : ""
            )}
          >
            <span>すべてのお店・施設</span>
            {props.placeCountByCategories && (
              <span className={styles.placesCount}>
                {props.placeCountByCategories["all"]}
              </span>
            )}
          </div>
        </a>
        <hr className="common-hr" />
      </div>
      <Loader show={props.categories.length == 0} color="green" small={false} />
      {props.categories.map((c, i) => (
        <React.Fragment key={i}>
          {filteredChildren[c.id].length > 0 && (
            <div className={styles.parentCategory}>
              <h3 className={styles.categoryHeader}>{c.name}</h3>
              <div className={styles.children}>
                <LayeredCategoryChildren
                  {...props}
                  children={filteredChildren[c.id]}
                />
              </div>
              <hr className="common-hr" />
            </div>
          )}
        </React.Fragment>
      ))}
    </React.Fragment>
  )
}

const Category = (props) => {
  const selected = props.category ? props.category.id : 0
  const handleClick = (e, category) => {
    e.preventDefault()
    props.onChange(category)
  }

  return (
    <React.Fragment>
      {props.layered && (
        <LayeredCategory onClick={handleClick} selected={selected} {...props} />
      )}
      {!props.layered && (
        <FlatCategory onClick={handleClick} selected={selected} {...props} />
      )}
    </React.Fragment>
  )
}

export default Category
